export default {
    state: {
        pageList: [],
        settings: [],
        pageEndSetting:[],
        pageEnd: {},
        storePageEndSettingStatus:'',
        storePageHeaderSettingStatus:'',
        pageBackgroundSetting:'rgb(255,255,255,1)',
        pageSetData:{}, // 除dargList外的数据
        frontendConfig:[],
        theme:'',
        pageTitle:'',
    },
    getters: {
        storeGetPageConfByName: (state) => (name) => {
            return state.pageList.find(
                page => page.pageName === name,
            );
        },
        storeGetBlockSettings: (state) => (block) => {
            console.log('state.settings--->',state.settings)
            return state.settings.find(
                item => item.blockInstanceId === block.id,
            );
        },
        getConfigByPage(state) {
            return (path) => state.pageConfigs.find(
                page => page.uri.includes(path) || page.manual_url && page.manual_url.includes(path)
            );
        },
        getConfigByPageNav(state) {
            return state.pageConfigs
        },

        getConfigState(state) {
            return state.pageEndSetting
        },
    },
    mutations: {
        setPageSetData(state,data){
            state.pageSetData = data
        },
        setPageConfigs(state, payload) {
            console.log(state,'fsdfd+++++')
            state.pageConfigs = payload;
        },
        storeSetPageList(state, pageList) {
            state.pageList = pageList;
        },
        storeSetPageSettings(state, settings) {
            state.settings = settings;
        },
        storePageEndSetting(state, pageEndSetting) {
            state.pageEndSetting = pageEndSetting
        },
        storePageEnd(state,pageEnd) {
            state.pageEnd = pageEnd
        },
        storePageEndSettingStatus(state, storePageEndSettingStatus) {
            state.storePageEndSettingStatus = storePageEndSettingStatus
        },
        storePageHeaderSettingStatus(state, storePageHeaderSettingStatus) {
            state.storePageHeaderSettingStatus = storePageHeaderSettingStatus
        },
        pageBackgroundSetting(state, pageBackgroundSetting) {
            state.pageBackgroundSetting = pageBackgroundSetting
        },
        frontendConfig(state, frontendConfig) {
            state.frontendConfig = frontendConfig
        },
        theme(state, theme) {
            state.theme = theme
        },
        pageTitle(state, pageTitle) {
            state.pageTitle = pageTitle
        },
    },
    actions: {
    },
};
